module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAASxJREFUOE/t1CFLxVAUB/D/2RgLFhFMgl9gsME99QWDSaOCwSSKRrNJTGajomgVNGoyGF7cGWywLyCYBLEYxhhHNpxcn8FtWB64Mhj/89u99xwu4Y8fmvSiKApc113v8p+qqm7SNM3t7DeQmRcBjFX1FsDbL+gsEa0BGInIU5v9AoMgmPN9f0xEpyJy0mWFzLyvqntFUYzyPH+taxowDMMZz/MeAMwDuOiCWZltAC9lWS5nWfbegMx8oKobRHTfE2viqrpCRNcictyAxpjD+p0kydEQ0K6fbtAxxiwB8OxjcByniOP40f7WacufY3Q1CRJRUZblZt3RFu0E9mnOPzgNg83MO6q6C+CuT3et7CoRnYnIeXt9ucy8paoLQ0AiehaRSwDVjxt7CGjXfABLSbAVhzGT+AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person7.png
// module id = VldK
// module chunks = 15